export default __webpack_public_path__ + "static/media/StrainCurve2Img.84fdcec4.png";